import axios from './fetch';
import domainFun from '../utils/domain';
const HOST = domainFun();

//根据行业code获取排序数据
export function getRegionCodeOriginData () {
  return axios.post(
    HOST + '/tel/getconfig.json'
  )
}
